(ns kyber.containers.not-found
  (:require
   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.components.base.text :as text]
   [kyber.components.base.link :as link]))

(def classes
  (styles->classes
   {:container {:display :flex
                :flex-direction :column
                :justify-content :center
                :align-items :center
                :width "100%"
                :height "100%"
                :flex "1 1 auto"}}))

(defn not-found
  [{:keys [source no-question-url questionnaire-type]}]
  [:div {:class (:container classes)}
   [text/display-20 :p (cond
                         (= source :curriculum)
                         "Curriculum not found"
                         (= source :activity)
                         "Activity not found"
                         (= source :question)
                         "Question not found"
                         :else
                         "Page not found")]
   [text/body-20 :p (str "If this problem persists, please contact your "
                         "administrator")]
   
   (when (and (= source :question) (not (= questionnaire-type "floating")))
        [link/primary-anchor-button
         {:style {:margin-top (gs [:spacing :p12])}
          :href no-question-url}
         [:<>
          (case questionnaire-type
            "pre-test" "Continue to Activity"
            "post-test" "Continue to Review"
            "evaluation" "Go Home"
            "Continue")]])])
